import { render } from "./EditUserGroupPlantMapping.vue?vue&type=template&id=26b12cae"
import script from "./EditUserGroupPlantMapping.vue?vue&type=script&lang=js"
export * from "./EditUserGroupPlantMapping.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__